import { render, staticRenderFns } from "./pcB.vue?vue&type=template&id=b4408496&scoped=true&"
import script from "./pcB.vue?vue&type=script&lang=js&"
export * from "./pcB.vue?vue&type=script&lang=js&"
import style0 from "./pcB.vue?vue&type=style&index=0&id=b4408496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4408496",
  null
  
)

export default component.exports